import type React from "react";
import { useId } from "react";

export interface LogoProps extends React.ComponentProps<"svg"> {
	title?: string;
}

// Obra Todo Dia mark. Letters follow `currentColor`; the crossbar keeps the
// brand gradient on every surface.
export function Logo({ title, ...props }: LogoProps) {
	const gradientId = useId();

	return (
		<svg
			data-slot="logo"
			viewBox="0 0 1066 424"
			role={title ? "img" : undefined}
			aria-hidden={title ? undefined : true}
			{...props}
		>
			{title ? <title>{title}</title> : null}
			<defs>
				<linearGradient
					id={gradientId}
					x1="308"
					y1="40.5"
					x2="773"
					y2="40.5"
					gradientUnits="userSpaceOnUse"
				>
					<stop style={{ stopColor: "var(--logo-bar)", stopOpacity: 0.6 }} />
					<stop offset="0.43" style={{ stopColor: "var(--logo-bar)" }} />
					<stop
						offset="1"
						style={{ stopColor: "var(--logo-bar-end)", stopOpacity: 0.8 }}
					/>
				</linearGradient>
			</defs>
			<path fill="currentColor" d="M495 99.0322H582V423.032H495V99.0322Z" />
			<path
				d="M773 0.532166H308L397 80.5322H702L773 0.532166Z"
				fill={`url(#${gradientId})`}
			/>
			<path
				fill="currentColor"
				d="M868 337.532H655.5V422.532H884C1092 404.032 1162 46.0322 873.003 0.532166H794.5L725.003 80.5322L873.003 81.5322C1038.5 100.542 1014.5 324.542 868 337.532Z"
			/>
			<path
				fill="currentColor"
				d="M369.5 74.0324C408.5 113.532 423.821 169.081 420.643 223.845C417.465 278.609 393.233 329.989 353.064 367.142C312.894 404.294 259.929 424.312 205.348 422.969C150.767 421.627 98.8405 399.029 60.5285 359.946C22.2164 320.863 0.516551 268.353 0.00910348 213.498C-0.498344 158.644 20.2263 105.737 57.8087 65.9456C95.3911 26.1539 146.891 2.5904 201.438 0.228706C255.984 -2.13299 316 13.5322 355.5 59.5324L303 114.532C277.261 91.5998 239.159 76.9042 204.79 78.3923C170.42 79.8803 137.971 94.7274 114.291 119.8C90.6106 144.872 77.5522 178.208 77.8719 212.771C78.1917 247.334 91.8645 280.421 116.005 305.046C140.145 329.672 172.863 343.911 207.254 344.757C241.645 345.603 275.018 332.99 300.328 309.58C325.638 286.171 340.906 253.797 342.909 219.29C344.912 184.784 338.431 154.739 316 128.532L369.5 74.0324Z"
			/>
		</svg>
	);
}
